import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./attributes-and-parameters.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./attributes-and-parameters.component.scss?ngResource";
import { Component } from "@angular/core";
import { AttributesAndParametersConstants } from "./attributes-and-parameters.constants";
import { FormControl, FormGroup } from "@angular/forms";
import { AttributesAndParametersService } from "./shared/services/attributes-and-parameters.service";
import { AppControllerService } from "../../../../app-controller.service";
import { AlertType } from "../../../../shared/models/alert";
import { ActivatedRoute, Router } from "@angular/router";
import { SharedConstants } from "../../../../shared/constants/shared.constants";
import { AttributesAndParametersRoutingConstants, SettingsRoutingConstants } from "../../settings-routing.constants";
import { SettingRoutingConstants } from "../../setting-routing.constants";
import { AutoUnsub } from "../../../../shared/decorators/autounsub.decorator";
let AttributesAndParametersComponent = class AttributesAndParametersComponent {
    router;
    route;
    attributesAndParametersService;
    appControllerService;
    attributesAndParametersFormGroup;
    contentPageHeading = AttributesAndParametersConstants.CONTENT_PAGE_HEADING;
    projectCycleFormControlName = AttributesAndParametersConstants.SELECT_GENERAL_VALUATION_RUN_FORM_CONTROL;
    selectprojectCycleLabel = AttributesAndParametersConstants.SELECT_GENERAL_VALUATION_RUN_LABEL;
    nooptionselected = SharedConstants.NO_OPTION_SELECTED;
    parameters = [];
    attributesAndFactors = [];
    menuLinks;
    noGvFoundForSelectedDateErrMsg = AttributesAndParametersConstants.NO_GV_FOUND_ERR_MSG;
    menuItems = {
        home: AttributesAndParametersConstants.HOME_MENU_HEADING,
        parameters: AttributesAndParametersConstants.PARAMETERS_MENU_HEADING,
        runSurvey: AttributesAndParametersConstants.VALUATION_RUN_SURVEY_HEADING,
        agriculturalActivity: AttributesAndParametersConstants.AGRICULATURAL_ACTIVITY_MENU_HEADINGS,
        depreciationFactor: AttributesAndParametersConstants.DEPRECIATION_FACTOR_MENU_HEADINGS,
        factorAdjustment: AttributesAndParametersConstants.FACTOR_ADJUSTMENT_MENU_HEADING,
        structureType: AttributesAndParametersConstants.STRUCTURE_TYPE_MENU_HEADING,
        valueAdjustment: AttributesAndParametersConstants.VALUE_ADJUSTMENT_MENU_HEADING,
    };
    projectCycleList = [];
    getProjectCycleSubscription;
    getExistingSurveysSubscription;
    constructor(router, route, attributesAndParametersService, appControllerService) {
        this.router = router;
        this.route = route;
        this.attributesAndParametersService = attributesAndParametersService;
        this.appControllerService = appControllerService;
        this.initForm();
    }
    ngOnInit() {
        this.attributesAndParametersService.selectedprojectCycleId = null;
        this.getprojectCycle();
        this.getMenuLinks();
        this.routeToHome();
    }
    routeToHome() {
        this.router.navigate([AttributesAndParametersRoutingConstants.HOME_ROUTE], {
            relativeTo: this.route,
        });
    }
    ngOnDestroy() {
        this.attributesAndParametersService.selectedprojectCycleId = null;
    }
    initForm() {
        // initialise the attribute and parameters form
        this.attributesAndParametersFormGroup = new FormGroup({
            selectprojectCycle: new FormControl(null),
        });
    }
    onSelectprojectCycle() {
        const valuationRunId = this.attributesAndParametersFormGroup.get(this.projectCycleFormControlName).value;
        this.attributesAndParametersService.selectedprojectCycleId = valuationRunId;
        this.router.navigate([
            this.appControllerService.selectedModuleID + "",
            SettingRoutingConstants.SETTINGS_ROUTE,
            SettingsRoutingConstants.PvAttributesAndParameters,
            AttributesAndParametersRoutingConstants.HOME_ROUTE,
        ]);
        this.getExistingSurveys();
    }
    getExistingSurveys() {
        const params = {
            id: this.attributesAndParametersService.selectedprojectCycleId,
        };
        this.getExistingSurveysSubscription = this.attributesAndParametersService
            .getExistingSurveys(this.attributesAndParametersService.selectedprojectCycleId, params)
            .subscribe({
            next: (value) => {
                this.attributesAndParametersService.existingSurveys = value;
            },
        });
    }
    getprojectCycle() {
        const moduleId = this.appControllerService.selectedModuleID;
        const params = {
            $filter: `moduleId eq ${moduleId} and deleted eq false and completed eq false`,
            $orderby: "fromDate",
        };
        this.getProjectCycleSubscription = this.attributesAndParametersService
            .getprojectCycle(params)
            .subscribe({
            next: (generalValuationRun) => {
                if (generalValuationRun.length > 0) {
                    this.projectCycleList = generalValuationRun;
                    this.projectCycleList.sort((a, b) => a.name?.localeCompare(b?.name));
                }
                else {
                    this.appControllerService.showMessage(this.noGvFoundForSelectedDateErrMsg, AlertType.Warning);
                }
            },
        });
    }
    getMenuLinks() {
        const emptySpaceRe = new RegExp(" ", "gi");
        const dashRe = new RegExp("-", "gi");
        const slashRe = new RegExp("/", "gi");
        this.menuLinks = new Array();
        Object.keys(this.menuItems).forEach((menuHeadingKey) => {
            const route = this.menuItems[menuHeadingKey].toLocaleLowerCase();
            this.menuLinks.push({
                // @ts-ignore
                text: this.menuItems[menuHeadingKey], // @ts-ignore
                address: route
                    .toLowerCase()
                    .replace(emptySpaceRe, "")
                    .replace(dashRe, "")
                    .replace(slashRe, ""),
            });
        });
    }
    static ctorParameters = () => [
        { type: Router },
        { type: ActivatedRoute },
        { type: AttributesAndParametersService },
        { type: AppControllerService }
    ];
};
AttributesAndParametersComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-attributes-and-parameters",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsub()
], AttributesAndParametersComponent);
export { AttributesAndParametersComponent };
